export default {"src":"/_next/static/media/upgrade.d3aa4666.svg","height":64,"width":64};